import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { RuoloDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class RuoloApiClient extends BaseCRUDApiClient<RuoloDto> {
  baseUrl = this.config.apiEndpoint + '/ruolo';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
